import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-event-payload-dialog',
  standalone: false,
  templateUrl: './event-payload-dialog.component.html',
  styleUrl: './event-payload-dialog.component.css'
})
export class EventPayloadDialogComponent {
  payload: string | null;
  formatted: string | null;
  copied = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { payload: string | null },
    private dialogRef: MatDialogRef<EventPayloadDialogComponent>
  ) {
    this.payload = data.payload || null;
    this.formatted = this.tryFormat(this.payload);
  }

  private tryFormat(payload: string | null): string | null {
    if (!payload) return null;
    try {
      return JSON.stringify(JSON.parse(payload), null, 2);
    } catch {
      return payload;
    }
  }

  copy(): void {
    navigator.clipboard.writeText(this.formatted ?? '');
    this.copied = true;
    setTimeout(() => this.copied = false, 2000);
  }

  close(): void {
    this.dialogRef.close();
  }
}
